import React, { useEffect, useState } from "react";
import { addMobileNumber, verifyMobileNumber } from "services";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  TextInputBase,
} from "@reusejs/react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../../layouts/Loader";
import { setBidderMobile, clearBidderMobile } from "store";
import Router from "next/router";

export default function AddMobile() {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });
  const tempMobileNumber = useSelector((state: any) => {
    return state.bidderAuth.mobile;
  });

  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [showVerificationInput, setShowVerificationInput] = useState(false);

  const mobileForm = useBetaForm({
    type: "mobile_number",
    value: tempMobileNumber ? tempMobileNumber : "", // mobile number
    otp: "",
  });

  const mobile_form_constraints = {
    value: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  useEffect(() => {
    mobileForm.setValidationRules(mobile_form_constraints);
  }, []);

  const handleSubmitMobile = async () => {
    try {
      if (mobileForm.validate()) {
        mobileForm.startProcessing();
        const data: any = await addMobileNumber(mobileForm.value);
        mobileForm.finishProcessing();
        dispatch(setBidderMobile(mobileForm.value.value));
        setShowVerificationInput(true); // Show verification input after adding mobile number
      }
    } catch (error: any) {
      mobileForm.finishProcessing();
      console.log("check here error", error);
      if (error?.response?.data?.errors) {
        mobileForm.setErrors(error.response.data.errors);
      }
    }
  };

  const handleVerifyMobile = async () => {
    try {
      if (mobileForm.validate()) {
        mobileForm.startProcessing();
        const data: any = await verifyMobileNumber(mobileForm.value);
        // await new Promise((resolve) => setTimeout(resolve, 5000));
        mobileForm.finishProcessing();
        // console.log("chekc here data::>", data);
        if (data) {
          dispatch(clearBidderMobile());
          setIsMobileVerified(true);
          // Router.reload("/onboarding");
          // Router.replace("/onboarding");
          // window.location.href = "/onboarding";
        }
      }
    } catch (error: any) {
      mobileForm.finishProcessing();
      console.log("check here error", error);
      if (error?.response?.data?.errors) {
        mobileForm.setErrors(error.response.data.errors);
      }
    }
  };

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
      {!isMobileVerified && (
        <>
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Add mobile number
            </h2>
          </div>
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
            <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
              <form className="space-y-6" action="#" method="POST">
                <div>
                  <TextInputBase
                    autoComplete="off"
                    labelBaseProps={{
                      label: "Mobile Number",
                    }}
                    name={"value"}
                    onChange={(val) => {
                      mobileForm.setField("value", val);
                    }}
                    placeholder={"Enter mobile number"}
                    type={"text"}
                    error={
                      mobileForm.errors.get("value") ? (
                        <p className="mt-2 text-sm text-red-500">
                          {mobileForm.errors.get("value")[0]}
                        </p>
                      ) : null
                    }
                    value={mobileForm.getField("value")}
                    htmlFor={"value"}
                    disabled={showVerificationInput}
                  />
                </div>

                {showVerificationInput && (
                  <div>
                    <TextInputBase
                      autoComplete="off"
                      labelBaseProps={{
                        label: "OTP",
                      }}
                      name={"otp"}
                      onChange={(val) => {
                        mobileForm.setField("otp", val);
                      }}
                      placeholder={"Enter OTP"}
                      type={"text"}
                      error={
                        mobileForm.errors.get("otp") ? (
                          <p className="mt-2 text-sm text-red-500">
                            {mobileForm.errors.get("otp")[0]}
                          </p>
                        ) : null
                      }
                      value={mobileForm.getField("otp")}
                      htmlFor={"otp"}
                    />
                  </div>
                )}

                <div className="col-span-2 flex justify-center">
                  {showVerificationInput ? (
                    <ButtonBase
                      variant="primary"
                      label={"Verify Mobile"}
                      onClick={() => handleVerifyMobile()}
                      buttonBaseClasses={{
                        font: "text-base font-medium",
                        backgroundColor: "bg-blue-600 hover:bg-blue-700",
                        textColor: "text-white",
                        border: "any",
                        width: "w-full",
                        padding: "px-4 py-2",
                      }}
                      busy={mobileForm.busy}
                      busyText={<Loader height="h-6" width="w-6" />}
                    />
                  ) : (
                    <ButtonBase
                      variant="primary"
                      label={"Add Mobile"}
                      onClick={() => handleSubmitMobile()}
                      buttonBaseClasses={{
                        font: "text-base font-medium",
                        backgroundColor: "bg-blue-600 hover:bg-blue-700",
                        textColor: "text-white",
                        border: "any",
                        width: "w-full",
                        padding: "px-4 py-2",
                      }}
                      busy={mobileForm.busy}
                      busyText={<Loader height="h-6" width="w-6" />}
                    />
                  )}
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
